import React, { useState, useRef } from "react";
import DropDownList from "../../../Patient/partial/DropdownList";

const NewFoodIntakeForm = ({ onSubmit, onCancel }) => {
    // local state
    const [meal, setMeal] = useState(null);

    // ref
    const foodRef = useRef(null);
    const amountTakenRef = useRef(null);
    const datetimeRef = useRef(new Date());
    const preferenceRef = useRef(new Date());
    return (
        <form
            method="POST"
            onSubmit={event => {
                event.preventDefault();
                onSubmit({
                    meal,
                    amountTaken: amountTakenRef.current.value,
                    datetime: datetimeRef.current.value,
                    foodOffered: foodRef.current.value,
                    preference: preferenceRef.current.value
                });
            }}
        >
            <div className="form-row">
                <div className="col">
                    <DropDownList
                        items={[
                            { id: 1, name: "Breakfast" },
                            { id: 2, name: "Lunch" },
                            { id: 3, name: "Dinner" },
                            { id: 4, name: "Supper" },
                            { id: 5, name: "Additional Food & Fluid" }
                        ]}
                        title="Select Meal"
                        onSelect={i => setMeal(i.name)}
                    />
                </div>
                <div className="col">
                    <label htmlFor="food-id">Food Offered*</label>
                    <input type="text" className="form-control input-height" id="food-id" required ref={foodRef} aria-describedby="food-id" placeholder="enter food offered" />
                </div>
            </div>
            <div className="form-row">
                <div className="col">
                    <label htmlFor="amount-taken">Amount Taken*</label>
                    <input type="text" className="form-control input-height" id="amount-taken" required ref={amountTakenRef} aria-describedby="amount-taken" placeholder="enter amount taken" />
                </div>

                <div className="col">
                    <label htmlFor="date-taken">Date & Time*</label>
                    <input type="datetime-local" className="form-control input-height" id="date-taken" required ref={datetimeRef} aria-describedby="date-taken" />
                </div>
            </div>
            <div className="form-group m-b-20">
                <label htmlFor="preference-id">Preference/Cultural Needs</label>
                <textarea name="preference-id" id="preference-id" ref={preferenceRef} className="form-control form-control-textarea" rows="6" placeholder="enter preference/ cultural needs"></textarea>
            </div>
            <div className="form-group text-center">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                    Submit <i className="material-icons">arrow_right_alt</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>
            </div>
        </form>
    );
};

export default NewFoodIntakeForm;
